const GET_DETAIL_BRANCH_BY_ID = 'GET_DETAIL_BRANCH_BY_ID'
const GET_DETAIL_BRANCH_BY_ID_SUCCESS = 'GET_DETAIL_BRANCH_BY_ID_SUCCESS'

const PUT_BRANCH = 'PUT_BRANCH'
const PUT_BRANCH_SUCCESS = 'PUT_BRANCH_SUCCESS'

const POST_BRANCH = 'POST_BRANCH'
const POST_BRANCH_SUCCESS = 'POST_BRANCH_SUCCESS'

const GET_BRANCHES_PAGES = 'GET_BRANCHES_PAGES'
const GET_BRANCHES_PAGES_SUCCESS = 'GET_BRANCHES_PAGES_SUCCESS'

const GET_BRANCHES_HISTORIES_PAGES = 'GET_BRANCHES_HISTORIES_PAGES'
const GET_BRANCHES_HISTORIES_PAGES_SUCCESS = 'GET_BRANCHES_HISTORIES_PAGES_SUCCESS'

const GET_BRANCH_OTHER_LIST = 'GET_BRANCH_OTHER_LIST'
const GET_BRANCH_OTHER_LIST_SUCCESS = 'GET_BRANCH_OTHER_LIST_SUCCESS'

const GET_BRANCHES_LIST = 'GET_BRANCHES_LIST'
const GET_BRANCHES_LIST_SUCCESS = 'GET_BRANCHES_LIST_SUCCESS'

const GET_BRANCH_IGARASHI_LIST = 'GET_BRANCH_IGARASHI_LIST'
const GET_BRANCH_IGARASHI_LIST_SUCCESS = 'GET_BRANCH_IGARASHI_LIST_SUCCESS'

const GET_BRANCH_BETTING_RATE_TYPE = 'GET_BRANCH_BETTING_RATE_TYPE'
const GET_BRANCH_BETTING_RATE_TYPE_SUCCESS = 'GET_BRANCH_BETTING_RATE_TYPE_SUCCESS'

const BranchesType = {
  GET_DETAIL_BRANCH_BY_ID,
  GET_DETAIL_BRANCH_BY_ID_SUCCESS,

  PUT_BRANCH,
  PUT_BRANCH_SUCCESS,

  POST_BRANCH,
  POST_BRANCH_SUCCESS,

  GET_BRANCHES_PAGES,
  GET_BRANCHES_PAGES_SUCCESS,

  GET_BRANCH_OTHER_LIST,
  GET_BRANCH_OTHER_LIST_SUCCESS,

  GET_BRANCHES_LIST,
  GET_BRANCHES_LIST_SUCCESS,

  GET_BRANCH_IGARASHI_LIST,
  GET_BRANCH_IGARASHI_LIST_SUCCESS,

  GET_BRANCH_BETTING_RATE_TYPE,
  GET_BRANCH_BETTING_RATE_TYPE_SUCCESS,

  GET_BRANCHES_HISTORIES_PAGES,
  GET_BRANCHES_HISTORIES_PAGES_SUCCESS

}

export default BranchesType
